"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleSelectInput = void 0;
const react_1 = __importStar(require("react"));
const SelectPill_1 = require("../buttons/SelectPill");
const SendButton_1 = require("../buttons/SendButton");
const MultipleSelectInput = ({ onSubmit, items, buttonLabel, }) => {
    const [multipleSelectedItems, setMultipleSelectedItems] = (0, react_1.useState)([]);
    const handleMultipleSelectItemClick = (item) => {
        const itemIndex = multipleSelectedItems.indexOf(item);
        const itemExists = itemIndex !== -1;
        if (itemExists) {
            multipleSelectedItems.splice(itemIndex, 1);
            setMultipleSelectedItems([...multipleSelectedItems]);
            return;
        }
        setMultipleSelectedItems([...multipleSelectedItems, item]);
    };
    return (react_1.default.createElement("div", { className: "flex flex-row items-start w-full text-base" },
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("div", { className: "flex flex-row flex-wrap" }, items.map((item, index) => {
                return (react_1.default.createElement(SelectPill_1.SelectPill, { key: index, textContent: item, onClick: () => handleMultipleSelectItemClick(item) }));
            })),
            react_1.default.createElement("div", { className: "flex flex-row" },
                react_1.default.createElement("div", { className: "flex flex-1" }, multipleSelectedItems.length > 0 && (react_1.default.createElement(SendButton_1.SendButton, { onClick: () => onSubmit(multipleSelectedItems.join(", ")), label: buttonLabel })))))));
};
exports.MultipleSelectInput = MultipleSelectInput;
//# sourceMappingURL=MultipleSelectInput.js.map